import BootstrapField from '../utility/BootstrapField';
// import CloneDeep from 'lodash.clonedeep';
// import DeepDiff from 'deep-diff';


// As private as it gets.
// let originalLaneClosureBlockLaneData = null;

export default class LaneClosureBlockLane {
	constructor(data) {
		if (!data) {
			data = {};
		}
		Object.assign(this, {
			laneId: new BootstrapField({
				value: data.laneId ||  null,
			}),
			peakId: new BootstrapField({
				value:  typeof data.peakId === 'number' ? data.peakId:  null,
			}),
			peakReason: new BootstrapField({
				value: data.peakReason || null,
			})
			,inEffect: new BootstrapField({
				value:  typeof data.inEffect === 'number' ? data.inEffect:  null
			})
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// originalLaneClosureBlockLaneData = CloneDeep(this);
	}

	validate() {
		let errors = [];
		let flag = true;

		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);
		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getRawValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);
		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalLaneClosureBlockLaneData.getRawValue(),  this.getRawValue());

		// return !IsEqual(originalLaneClosureBlockLaneData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalLaneClosureBlockLaneData);
	}
	saveChanges() {
		// originalLaneClosureBlockLaneData = CloneDeep(this);
	}
}